import React from 'react';
import PropTypes from 'prop-types';

const TYPE_TABS = [
  { key: 'all', label: 'All' },
  { key: 'images', label: 'Images' },
  { key: 'other', label: 'Other' },
];

const SORTS = [
  { value: 'newest', label: 'Newest' },
  { value: 'oldest', label: 'Oldest' },
  { value: 'name', label: 'Name A-Z' },
  { value: 'size-desc', label: 'Largest' },
  { value: 'size-asc', label: 'Smallest' },
];

const selectClass = 'font-americaMonoRegular text-xs text-black bg-white border-1 border-black rounded py-1 px-2 outline-none mr-3 mb-2';

const MamFilterBar = ({ filters, onChange, uploaders, allTags }) => (
  <div className="w-full flex flex-row flex-wrap items-center my-2">
    <div className="flex mr-4 mb-2">
      {TYPE_TABS.map(tab => (
        <button
          key={tab.key}
          type="button"
          onClick={() => onChange({ typeKey: tab.key })}
          className={`font-americaMonoBold text-xs uppercase px-4 py-1 mr-1 rounded-full ${filters.typeKey === tab.key ? 'bg-black text-white' : 'text-black border-1 border-black'}`}
        >
          {tab.label}
        </button>
      ))}
    </div>
    <select className={selectClass} value={filters.visibility} onChange={e => onChange({ visibility: e.target.value })}>
      <option value="all">All visibilities</option>
      <option value="public">Public</option>
      <option value="private">Private</option>
    </select>
    {uploaders.length > 0 && (
      <select className={selectClass} value={filters.uploadedBy} onChange={e => onChange({ uploadedBy: e.target.value })}>
        <option value="">Any uploader</option>
        {uploaders.map(u => <option key={u} value={u}>{u}</option>)}
        <option value="unknown">Unknown</option>
      </select>
    )}
    {allTags.length > 0 && (
      <select className={`${selectClass} max-w-240`} value={filters.tag} onChange={e => onChange({ tag: e.target.value })}>
        <option value="">Any tag</option>
        {allTags.map(t => <option key={t} value={t}>{t}</option>)}
      </select>
    )}
    <select className={selectClass} value={filters.sort} onChange={e => onChange({ sort: e.target.value })}>
      {SORTS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
    </select>
  </div>
);

MamFilterBar.propTypes = {
  filters: PropTypes.shape({
    typeKey: PropTypes.string,
    visibility: PropTypes.string,
    uploadedBy: PropTypes.string,
    tag: PropTypes.string,
    sort: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  uploaders: PropTypes.arrayOf(PropTypes.string),
  allTags: PropTypes.arrayOf(PropTypes.string),
};

MamFilterBar.defaultProps = {
  uploaders: [],
  allTags: [],
};

export default MamFilterBar;
